<template>
  <div class="container mt-2 px-2">
    <div class="card shadow p-4">
      <h3 class="mb-4">Movimientos de Inventario - Restaurante</h3>

      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Formulario -->
      <div class="border rounded p-3 mb-4 bg-light">
        <h5 class="mb-3">Registrar Movimiento</h5>

        <div class="row g-3 align-items-end">
          <!-- Buscador -->
          <div class="col-md-3">
            <label class="form-label">Buscar producto</label>
            <input
              v-model="busquedaProducto"
              type="text"
              class="form-control"
              placeholder="Escribe para filtrar productos..."
            />
          </div>

          <!-- Select de productos (filtrado) -->
          <div class="col-md-3">
            <label class="form-label">Producto</label>
            <select v-model="form.IdProductoRestaurante" class="form-select">
              <option disabled value="">Seleccione producto</option>
              <option
                v-for="p in productosFiltrados"
                :key="p.IdProductoRestaurante"
                :value="p.IdProductoRestaurante"
              >
                {{ p.NombreProducto }}
              </option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">Origen</label>
            <select v-model="form.Origen" class="form-select">
              <option disabled value="">Origen</option>
              <option :value="0">General</option>
              <option :value="1">Cocina</option>
              <option :value="2">Barra</option>
            </select>
          </div>
          <!-- Stock disponible -->
          <div class="col-md-2 d-flex align-items-end">
            <div v-if="cargandoStock" class="text-muted small">
              <span class="spinner-border spinner-border-sm me-1"></span>
              Cargando stock...
            </div>
            <div v-else-if="stockDisponible !== null" class="alert alert-info py-1 px-2 mb-0 small">
              <strong>Stock disponible:</strong> {{ stockDisponible }} unidades
            </div>
            <div v-else class="text-muted small">
              Seleccione producto y origen
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label">Destino</label>
            <select v-model="form.Destino" class="form-select">
              <option disabled value="">Destino</option>
              <option :value="0">General</option>
              <option :value="1">Cocina</option>
              <option :value="2">Barra</option>
            </select>
          </div>

          <div class="col-md-1">
            <label class="form-label">Cantidad</label>
            <input v-model.number="form.Cantidad" type="number" min="1" class="form-control" placeholder="Cantidad" />
          </div>

          <div class="col-12 col-md-1 d-grid">
            <button class="btn btn-success" @click="registrarMovimiento">Registrar</button>
          </div>
        </div>
      </div>

      <!-- Tabla de movimientos -->
      <div>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="m-0">Historial de Movimientos</h5>
        </div>

        <div class="table-responsive">
          <table class="table table-bordered text-center align-middle">
            <thead class="table-light">
              <tr>
                <th>Fecha</th>
                <th>Producto</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Cantidad</th>
                <th>Empleado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="movimientos.length === 0">
                <td colspan="7">No hay movimientos registrados.</td>
              </tr>
              <tr
                v-for="m in movimientos"
                :key="m.IdMovimientoInventariosRestaurante || m.IdMovimientoInventariosRestaurant || m.IdMovimientoInventarios"
              >
                <td>{{ formatearFecha(m.FechaMovimiento) }}</td>
                <td>{{ m.producto?.NombreProducto || '-' }}</td>
                <td>{{ getNombreInventario(m.Origen) }}</td>
                <td>{{ getNombreInventario(m.Destino) }}</td>
                <td>{{ m.Cantidad }}</td>
                <td>{{ m.empleado ? (m.empleado.Nombres + ' ' + m.empleado.Apellidos) : '-' }}</td>
                <td class="text-nowrap">
                  <button
                    class="btn btn-outline-danger btn-sm"
                    :disabled="Number(m.Cantidad) === 0"
                    v-if="Number(m.Cantidad) > 0"
                    @click="abrirModalReversion(m)"
                  >
                    Revertir movimiento
                  </button>
                  <span v-else class="badge bg-secondary">Revertido</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- Mini Modal Confirmación Reversión -->
    <div v-if="mostrarModalReversion" class="modal-backdrop" @click.self="cerrarModalReversion">
      <div class="modal-content small" @click.stop>
        <div class="modal-header">
          <h6 class="modal-title text-danger">Confirmar reversión</h6>
          <button type="button" class="btn-close" @click="cerrarModalReversion"></button>
        </div>
        <div class="modal-body">
          <p class="mb-1"><strong>Producto:</strong> {{ movimientoSeleccionado?.producto?.NombreProducto || '-' }}</p>
          <p class="mb-1"><strong>Origen:</strong> {{ getNombreInventario(movimientoSeleccionado?.Origen) }}</p>
          <p class="mb-1"><strong>Destino:</strong> {{ getNombreInventario(movimientoSeleccionado?.Destino) }}</p>
          <p class="mb-0"><strong>Cantidad a revertir:</strong> {{ movimientoSeleccionado?.Cantidad }}</p>
          <p class="text-muted small mt-2">Se devolverá el producto al origen: {{ getNombreInventario(movimientoSeleccionado?.Origen) }}</p>
        </div>
        <div class="modal-footer d-flex justify-content-center gap-2">
          <button class="btn btn-secondary btn-sm" @click="cerrarModalReversion">Cancelar</button>
          <button class="btn btn-danger btn-sm" @click="confirmarReversion">Revertir</button>
        </div>
      </div>
    </div>
    <!-- /Mini Modal -->
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config";
import store from "@/store";

export default {
  name: "MovimientoInventariosRestaurante",
  data() {
    return {
      productos: [],
      movimientos: [],
      form: {
        IdProductoRestaurante: "",
        Cantidad: null,
        Origen: "",
        Destino: ""
      },
      busquedaProducto: "",
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },

      // modal reversion
      mostrarModalReversion: false,
      movimientoSeleccionado: null,

      // stock disponible
      stockDisponible: null,
      cargandoStock: false,
    };
  },
  computed: {
    empleadoId() {
      return store.getters.getUser?.IdEmpleado || null;
    },
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    productosFiltrados() {
      const q = (this.busquedaProducto || "").toLowerCase().trim();
      if (!q) return this.productos;
      return this.productos.filter(p =>
        (p.NombreProducto || "").toLowerCase().includes(q)
      );
    }
  },
  watch: {
    'form.IdProductoRestaurante': 'obtenerStock',
    'form.Origen': 'obtenerStock',
  },
  methods: {
    // Obtener stock disponible
    async obtenerStock() {
      // Resetear stock si no hay producto u origen seleccionado
      if (!this.form.IdProductoRestaurante || this.form.Origen === "") {
        this.stockDisponible = null;
        return;
      }

      this.cargandoStock = true;
      try {
        const { data } = await axios.get(`${API_URL}/movimientos-restaurante/stock/disponible`, {
          params: {
            IdProductoRestaurante: this.form.IdProductoRestaurante,
            Origen: this.form.Origen
          }
        });
        this.stockDisponible = data.stock;
      } catch (error) {
        this.stockDisponible = null;
        console.error("Error al obtener stock:", error);
      } finally {
        this.cargandoStock = false;
      }
    },

    // Retorna el nombre del inventario según el tipo
    getNombreInventario(tipo) {
      const tipoNum = Number(tipo);
      switch (tipoNum) {
        case 0: return 'General';
        case 1: return 'Cocina';
        case 2: return 'Barra';
        default: return '-';
      }
    },
    // modal reversion
    abrirModalReversion(mov) {
      this.movimientoSeleccionado = mov;
      this.mostrarModalReversion = true;
    },
    cerrarModalReversion() {
      this.mostrarModalReversion = false;
      this.movimientoSeleccionado = null;
    },
    async confirmarReversion() {
      if (!this.movimientoSeleccionado) return;
      try {
        const id = this.movimientoSeleccionado.IdMovimientoInventariosRestaurante;
        const { data } = await axios.post(`${API_URL}/movimientos-restaurante/${id}/revertir`);
        this.mostrarAlerta(data.message || "Reversión aplicada");
        this.cerrarModalReversion();
        this.cargarMovimientos();
        this.cargarProductos();
      } catch (error) {
        const msg = error.response?.data?.message || "No se pudo revertir";
        this.mostrarAlerta(msg, "danger");
      }
    },

    cerrarToast() { this.mostrarToast = false; },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    formatearFecha(f) {
      try { return new Date(f).toLocaleString("es-GT"); } catch { return f; }
    },

    // Cargas iniciales
    async cargarMovimientos() {
      try {
        const { data } = await axios.get(`${API_URL}/movimientos-restaurante`);
        this.movimientos = data;
      } catch {
        this.mostrarAlerta("Error al cargar movimientos", "danger");
      }
    },
    async cargarProductos() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-general-restaurante`);
        this.productos = data;
      } catch {
        this.mostrarAlerta("Error al cargar productos", "danger");
      }
    },

    // Registrar
    async registrarMovimiento() {
      if (!this.form.IdProductoRestaurante || !this.form.Cantidad || this.form.Origen === "" || this.form.Destino === "") {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      if (this.form.Origen === this.form.Destino) {
        this.mostrarAlerta("El origen y destino deben ser diferentes", "danger");
        return;
      }
      if (!this.empleadoId) {
        this.mostrarAlerta("No se encontró el empleado logueado", "danger");
        return;
      }

      try {
        const payload = { ...this.form, IdEmpleado: this.empleadoId };
        const { data } = await axios.post(`${API_URL}/movimientos-restaurante`, payload);
        this.mostrarAlerta(data.message || "Movimiento registrado");
        this.cargarMovimientos();
        this.form = { IdProductoRestaurante: "", Cantidad: null, Origen: "", Destino: "" };
        this.busquedaProducto = "";
        this.stockDisponible = null;
      } catch (error) {
        const msg = error.response?.data?.message || "Error al registrar movimiento";
        this.mostrarAlerta(msg, "danger");
      }
    },
  },
  mounted() {
    this.cargarMovimientos();
    this.cargarProductos();
  }
};
</script>

<style scoped>
/* Mini modal */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 420px;
  padding: 18px 18px 14px;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0,0,0,.25);
  z-index: 5001;
}
.modal-content.small { width: 420px; }
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: .25rem;
  border-bottom: 1px solid #eee;
}
.modal-body { padding: .75rem 0; }
.modal-footer { padding-top: .75rem; border-top: 1px solid #eee; }
</style>
